module.exports = __webpack_public_path__ + "img/whatsapp.27aa4764.svg";